import React from "react";
import { TbFlipHorizontal, TbFlipVertical } from "react-icons/tb";
import { MdOutlineRotate90DegreesCw, MdOutlineRotate90DegreesCcw } from "react-icons/md";

import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Slider } from "@/components/Slider";
import { Typography } from "@/components/Typography";

import { IMAGE_MIN_ZOOM, IMAGE_ZOOM_STEP, IMAGE_MAX_ZOOM, IMAGE_ROTATION_STEP } from "./utils";

import { ImageCropperSettingsProps } from "./types";

import "./styles.scss";

export default function ImageCropperSettings(props: ImageCropperSettingsProps) {
  const {
    zoom,
    rotation,
    dataTestId,
    onChangeZoom,
    onChangeRotation,
    onFlipHorizontal,
    onFlipVertical,
    translations,
  } = props;

  const rotateForward = () => {
    let nextRotation = Math.ceil((rotation + 1) / 90) * 90;
    if (nextRotation > 360) {
      nextRotation = 90;
    }

    onChangeRotation(nextRotation);
  };

  const rotateBackward = () => {
    let prevRotation = Math.floor((rotation - 1) / 90) * 90;
    if (prevRotation < 0) {
      prevRotation = 270;
    }

    onChangeRotation(prevRotation);
  };

  return (
    <>
      <div
        data-testid={dataTestId}
        className="image-cropper__settings__sliders"
      >
        <Slider
          title={translations?.cropperZoomLabel}
          defaultValue={zoom}
          onChange={onChangeZoom}
          min={IMAGE_MIN_ZOOM}
          step={IMAGE_ZOOM_STEP}
          max={IMAGE_MAX_ZOOM}
          className="image-cropper__settings__sliders--zoom"
        />
        <Slider
          title={translations?.cropperRotateLabel}
          defaultValue={rotation}
          onChange={onChangeRotation}
          step={IMAGE_ROTATION_STEP}
          max={360}
          className="image-cropper__settings__sliders--rotate"
        />
      </div>

      <div className="image-cropper__settings__buttons">
        <div>
          <Typography Tag="p">{translations?.cropperFlipLabel}</Typography>
          <div className="image-cropper__settings__buttons--rotate">
            <ButtonLib
              shape="outlined"
              dataQA="flip-horizontal"
              onClick={onFlipVertical}
              ariaLabel="Flip horizontal"
              iconLeft={<TbFlipHorizontal />}
            />
            <ButtonLib
              shape="outlined"
              dataQA="flip-vertical"
              ariaLabel="Flip vertical"
              onClick={onFlipHorizontal}
              iconLeft={<TbFlipVertical />}
            />
          </div>
        </div>

        <div>
          <Typography Tag="p">{translations?.cropperRotationLabel}</Typography>
          <div className="image-cropper__settings__buttons--flip">
            <ButtonLib
              shape="outlined"
              dataQA="rotate-forward"
              onClick={rotateForward}
              ariaLabel="Rotate forward"
              iconLeft={<MdOutlineRotate90DegreesCw />}
            />
            <ButtonLib
              shape="outlined"
              dataQA="rotate-backward"
              ariaLabel="Rotate backward"
              onClick={rotateBackward}
              iconLeft={<MdOutlineRotate90DegreesCcw />}
            />
          </div>
        </div>
      </div>
    </>
  );
}
